import React from "react";

const Biography = () => {
  return (
    <div className="Biography">
      <div class="border-indigo-500 text-white bg-gradient-to-r from-blue-100 via-blue-500 to-blue-100 mt-8">
        <div class="pt-6 sm:p-0 md:p-0 text-center md:text-center text-blue  -space-y-4">
          <p class="text-4xl p-5"> Biography </p>
        </div>
      </div>
      <figure class="flex  items-center justify-center p-8">
        <div class="box-content items-center justify-center h-64 sm:h-40 w-11/12 p-4 border-transparent  bg-blue-200 hover:shadow-lg hover:border-transparent ">
          <div class="h-full w-full border-2 bg-blue-50 over:bg-white hover:shadow-lg hover:border-transparent hover:bg-white">
            <br></br>
            <p class="text-sm sm:text-lg md:text-2xl">
              Thevathayarajh Thayananthan received Second Class Upper Division
              Honours (In Sri Lanka: 3.40/4.00 scale) in BTech in 2018 from the
              Uva Wellassa University of Sri Lanka. He has conducted a research
              study related to the "Development of a monitoring device for the
              fermentation stage of black tea manufacturing".
            </p>
            <br></br>
          </div>
        </div>
      </figure>

      <div class="border-indigo-500 text-white bg-gradient-to-r from-blue-100 via-blue-500 to-blue-100">
        <div class="pt-6 md:p-0 text-center md:text-center text-blue  -space-y-4">
          <p class="text-4xl p-5"> Career Highlights </p>
        </div>
      </div>
      <figure class="flex  items-center justify-center p-8">
        <div class="box-content items-center justify-center h-30 w-11/12 p-4 border-transparent  bg-blue-50 hover:shadow-lg hover:border-transparent ">
          <div class="h-full w-full bg-blue-50 border-2 over:bg-white hover:shadow-lg hover:border-transparent hover:bg-white">
            <br></br>
            <ul class="list-disc text-sm sm:text-lg md:text-2xl text-left p-2">
              <li>
                Member of IEEE student branch of Uva Wellassa University (2016 –
                2018).
              </li>
              <li>
                Volunteer resource person for seminar series of ordinary level
                organized by Uva Wellassa University students (2014-2016).
              </li>
              <li>
                Academic Subwarden, Uva Wellassa University (2019 – present).
              </li>
              <li>
                Faculty Advisor for Robotics and Automation Society (RAS)
                student chapter of IEEE Uva Wellassa University student branch
                (2021 – present).
              </li>
              <li>
                Resource person for the workshop on Engineering Machinery
                conducted by the Department of Science and Technology 2018.
              </li>
              <li>Student Mentor, Uva Wellassa University (2019 to-date).</li>
              <li>
                Coordinator of the Short Course in Robotics and Arduino
                programming (2019 – present).
              </li>
              <li>
                Program Review and SER group member for groups 3,4, and 8.
              </li>
              <li>
                Panel member in the stakeholder meeting for the curriculum
                revision 2020.
              </li>
              <li>
                Panel member in the International Research Conference of Uva
                Wellassa University 2020.
              </li>
              <li>
                Member (Activity 02) of the AHEAD Faculty Development Project of
                120 million, Uva Wellassa University from 2019-2022.
              </li>
              <li>
                Member of the organizing committee of the International Research
                Conference of Uva Wellassa University 2019.
              </li>
              <li>
                Member of the organizing committee of the International Research
                Conference of Uva Wellassa University 2020.
              </li>
              <li>
                Reviewer at the 2nd International Conference on Advancements in
                Computing organized by Sri Lanka Institute of Information
                Technology (SLIIT).
              </li>
              <li>
                Reviewer at the International Research Conference of Uva
                Wellassa University 2021.
              </li>
              <li>Member of organizing committee of the Convocation 2019.</li>
            </ul>
            <br></br>
          </div>
        </div>
      </figure>
      <div class="border-indigo-500 text-white bg-gradient-to-r from-blue-100 via-blue-500 to-blue-100">
        <div class="pt-6 md:p-0 text-center md:text-center text-blue  -space-y-4">
          <p class="text-4xl p-5"> Work Experience </p>
        </div>
      </div>
      <figure class="flex  items-center justify-center p-8">
        <div class="box-content items-center justify-center h-30 w-11/12 p-4 border-transparent  bg-blue-50 hover:shadow-lg hover:border-transparent ">
          <div class="h-full w-full bg-blue-50 border-2 over:bg-white hover:shadow-lg hover:border-transparent hover:bg-white">
            <br></br>
            <ul class="list-disc text-sm sm:text-lg md:text-2xl text-left p-2">
              <li>
                Lecturer (Probationary) at Uva Wellassa University: March 2019 -
                Present
              </li>
              <li>
                Academic Demonstrator at Uva Wellassa University: February 2018
                - March 2019
              </li>
              <li>
                Intern at Research and Development, MAS Initimates Vidiyal
                Division: September 2017 - February 2018
              </li>
            </ul>
            <br></br>
          </div>
        </div>
      </figure>
    </div>
  );
};

export default Biography;
